import React from 'react';

export default function Nose() {
	return (
		<g className="nose">
			<g className="pig-face">
				<path className="fill fill--dark snout" d="M206.12941,290.30185c0,11.73746-8.31462,15.17841-18.57121,15.17841
					c-10.25661,0-18.57123-3.44095-18.57123-15.17841c0-11.73743,11.73582-15.29324,18.57123-15.29324
					S206.12941,278.56442,206.12941,290.30185z" />
				<path className="fill fill--darker" d="M195.78223,294.78986c-1.76523,0-3.38077-1.29709-4.1158-3.30472
					c-0.98212-2.68362-0.03177-5.73251,2.11769-6.79666c0.4967-0.24606,1.02267-0.37106,1.56412-0.37106
					c1.7648,0,3.38034,1.29758,4.11536,3.30521c0.9817,2.68314,0.03178,5.73203-2.11768,6.79663
					C196.84962,294.66534,196.32324,294.78986,195.78223,294.78986L195.78223,294.78986z" />
				<path className="fill fill--darker" d="M179.33441,294.78986c-0.54102,0-1.06741-0.12451-1.56371-0.37061
					c-2.14987-1.06509-3.09979-4.11398-2.11768-6.79617c0.7346-2.00809,2.35014-3.30566,4.11537-3.30566
					c0.54102,0,1.06741,0.125,1.56369,0.37106c2.14946,1.06415,3.09981,4.11304,2.11769,6.79617
					C182.71518,293.49277,181.09964,294.78986,179.33441,294.78986z" />
			</g>
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Pig/Nose.js